import React from 'react';
import { ISwitchProps } from './SwitchProps'
import { FormControlLabel, FormGroup } from '@mui/material'
import { StyledSwitch } from './StyledSwitch'

import './Switch.scss'

const Switch = (props: ISwitchProps) => {
   return (
      <FormGroup>
         <FormControlLabel 
            classes={{
               root: props.isChecked? 'app-switch-form-control-label-checked' : 'app-switch-form-control-label'
            }}
            checked={Boolean(props.isChecked)} 
            control={<StyledSwitch onChange={(e: React.ChangeEvent<HTMLInputElement> ) => props.handleOnSwitch(e.target.checked)} data-test-id={props.dataTestId} id={`${props.additionalFormName}-switch-input`}/>} 
            label={props.label} 
         />
      </FormGroup>
   )
}

export default Switch
